"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.delay = exports.durationToAccString = exports.durationToString = exports.stringToDuration = void 0;
function stringToDuration(durationString) {
    if (!durationString) {
        return 0;
    }
    return durationString
        .split(':')
        .reverse()
        .reduce(function (duration, chunk, i) { return duration + parseInt(chunk, 10) * Math.pow(60, i); }, 0);
}
exports.stringToDuration = stringToDuration;
var chunksFromDuration = function (duration) {
    var chunks = [];
    var chunk;
    duration = Math.floor(duration);
    do {
        chunk = duration % 60;
        if (chunk <= 9) {
            chunk = "0".concat(chunk);
        }
        chunks.unshift(String(chunk));
        duration = Math.floor(duration / 60);
    } while (duration > 0);
    return chunks;
};
function durationToString(duration) {
    var chunks = chunksFromDuration(duration);
    if (chunks.length < 2) {
        chunks.unshift('00');
    }
    return chunks.join(':');
}
exports.durationToString = durationToString;
function durationToAccString(duration) {
    var chunks = chunksFromDuration(duration);
    var necessaryChunksLength = 3;
    var chunksLength = chunks.length;
    for (var i = 0; i < necessaryChunksLength - chunksLength; i++) {
        chunks.unshift('00');
    }
    return chunks.join(':');
}
exports.durationToAccString = durationToAccString;
function delay(duration) {
    return new Promise(function (resolve) {
        setTimeout(resolve, duration);
    });
}
exports.delay = delay;
//# sourceMappingURL=time.js.map